import React, { createContext, useContext } from "react"
import type { NavigateFunction } from "react-router-dom"
import { useLocation, useNavigate } from "react-router-dom"

import {
  AppContextProps,
  appContextDefaultValues,
  useAppContext
} from "@contexts/app_context"

type LeftNavigationContextProps = AppContextProps & {
  navigate: NavigateFunction
  currentPathname: string
  botStatus?: string | undefined
}

const defaultValues: LeftNavigationContextProps = {
  ...appContextDefaultValues,
  navigate: () => {},
  currentPathname: "/"
}

const LeftNavigationContext = createContext(defaultValues)

export function LeftNavigationContextProvider(props: {
  children: React.ReactNode | React.ReactNode[]
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const appContext = useAppContext()

  return (
    <LeftNavigationContext.Provider
      value={{
        ...defaultValues,
        ...appContext,
        navigate,
        currentPathname: location.pathname
      }}
    >
      {props.children}
    </LeftNavigationContext.Provider>
  )
}

export function useLeftNavigationContext() {
  const context = useContext(LeftNavigationContext)
  if (context === undefined) {
    throw new Error("LeftNavigation Context Error")
  }
  return context
}
